<template>
  <icon v-if="action.icon" :name="action.icon" class="action-icon" />
  <i v-else-if="action.iconClass" :class="['action-icon', action.iconClass]" aria-hidden="true"></i>
  <span class="link-text">{{ action.name }}</span>
  <i class="icon-chevron-right" aria-hidden="true"></i>
</template>
<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

defineProps({
  action: {
    type: Object,
    required: true,
  },
});
const Icon = defineAsyncComponent(() => import('@/app/components/Icon.vue'));
</script>
